<template>
  <div style="display: flex">
    <v-chip-group column active-class="primary--text">
      <v-chip style="margin:5px" outlined v-for="(tag, index) in controlBar.tags" :disabled="!tag.status" :key="index + tag.value">
        <v-icon color="grey">{{tag.icon}}</v-icon>{{ tag.value }}
      </v-chip>
    </v-chip-group>
    <v-switch v-model="controlBar.edit_status" label="編輯" style="margin: 8px;max-height: 5px" @change="setPermissionDialogStatus"></v-switch>
    <permissionDialog/>
  </div>
</template>

<script>
import permissionDialog from '../../dialog/permissionDialog/permissionDialog.vue'
export default {
  name: 'controlBar',
  data: () => ({
    controlBar: {}
  }),
  components: {
    permissionDialog
  },
  created () {
    this.controlBar = this.$store.state.controlBar
  },
  methods: {
    setPermissionDialogStatus () {
      if (this.controlBar.edit_status) {
        this.$store.commit('setPermissionDialogStatus', true)
        this.$store.commit('setSaveBtnStatus', true)
      } else {
        this.$store.commit('setSaveBtnStatus', false)
      }
    }
  }
}
</script>

<style scoped>

</style>
